/* MotoPa v7 parts list: short names, bike-generation filter, find-in-list, part-type jump chips,
   + / - basket stepper (Shopify AJAX cart), bottom basket bar, list/photos switch, merges extra pages. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mpl]');
  if (!root || root.getAttribute('data-mpl-ready')) return;
  root.setAttribute('data-mpl-ready', '1');

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-mpl-cfg]').textContent); } catch (e) { cfg = {}; }
  var GN = cfg.groups || [];
  var GS = cfg.short || [];
  var SUBS = {
    'sub-front-fairings': 'Front panels & fairings', 'sub-side-panels': 'Side panels & belly covers', 'sub-mudguards-fenders': 'Mudguards & fenders',
    'sub-floorboards-steps': 'Floorboards & foot steps', 'sub-body-fittings': 'Body fittings, lids & brackets', 'sub-panel-kits': 'Full panel kits',
    'sub-headlights': 'Headlights', 'sub-tail-lights': 'Tail lights', 'sub-indicators': 'Indicators', 'sub-mirrors': 'Mirrors',
    'sub-brake-pads': 'Brake pads', 'sub-brake-shoes': 'Brake shoes', 'sub-brake-discs': 'Brake discs', 'sub-brake-calipers': 'Calipers & caliper parts',
    'sub-brake-levers-cables': 'Brake levers, cables & master cylinders', 'sub-shock-absorbers': 'Shock absorbers', 'sub-forks-yokes': 'Forks, yokes & steering stems',
    'sub-steering-bearings': 'Steering head bearings', 'sub-wheels-axles': 'Wheels & axles', 'sub-bearings-seals': 'Wheel & engine bearings',
    'sub-engine-mounts': 'Engine mounts & hangers', 'sub-tyres': 'Tyres', 'sub-engine-internals': 'Pistons, cylinders, valves & timing',
    'sub-gaskets-seals': 'Gaskets & oil seals', 'sub-cooling': 'Cooling: pumps, radiators & thermostats', 'sub-fuel-system': 'Fuel pumps & fuel system',
    'sub-air-filters-intake': 'Air filters & air boxes', 'sub-exhausts': 'Exhausts & heat shields', 'sub-drive-belts': 'Drive belts & belt kits',
    'sub-variator': 'Variator, rollers & sliders', 'sub-clutch': 'Clutch & clutch bell', 'sub-gearbox-final-drive': 'Gearbox & final drive',
    'sub-ignition': 'Spark plugs, caps & coils', 'sub-switches-locks-keys': 'Switches, locks & smart keys', 'sub-charging-starting': 'Starter motors, stators & regulators',
    'sub-instruments-sensors': 'Sensors & instruments', 'sub-handlebars-levers': 'Handlebars & levers', 'sub-cables': 'Cables', 'sub-stands': 'Main & side stands',
    'sub-seats': 'Seats', 'sub-fasteners-hardware': 'Fasteners, springs & hardware', 'sub-spark-plugs': 'Spark plugs', 'sub-filters': 'Filters',
    'sub-bearings': 'Bearings', 'sub-clips-fasteners': 'Clips & fasteners', 'sub-oils': 'Oils & lubricants', 'sub-batteries': 'Batteries',
    'sub-service-kits': 'Service kits', 'sub-racks-luggage': 'Racks & luggage', 'sub-screens': 'Windscreens', 'sub-phone-mounts': 'Phone mounts & chargers'
  };
  function subLabel(t) { return t ? (SUBS[t] || t.replace(/^sub-/, '').replace(/-/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); })) : ''; }
  var MONEY = cfg.money || '£{{amount}}';
  var body = root.querySelector('[data-mpl-body]');
  var findInput = root.querySelector('[data-mpl-q]');
  var catsNav = root.querySelector('[data-mpl-cats]');
  var gensBox = root.querySelector('[data-mpl-gens]');
  var countEl = root.querySelector('[data-mpl-count]');
  var noneEl = root.querySelector('[data-mpl-none]');
  var moreEl = root.querySelector('[data-mpl-pages]');
  var dock = root.querySelector('[data-mpl-dock]');
  var toastEl = root.querySelector('[data-mpl-toast]');
  var tools = root.querySelector('[data-mpl-tools]');

  var cartQty = {};      // variant id -> quantity in the Shopify cart (server truth)
  var want = {};         // variant id -> quantity the customer asked for (optimistic)
  var timers = {};
  var inflight = {};
  var pending = {};      // variant id -> toast label of a change made while a request was still running
  (cfg.cart || []).forEach(function (l) { cartQty[l[0]] = (cartQty[l[0]] || 0) + l[1]; });
  var state = { gen: '', term: '' };
  var chipPrefix = '';

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    var p = n.split('.');
    var whole = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return whole;
      if (k === 'amount_with_comma_separator') return p[0] + ',' + p[1];
      if (k === 'amount_no_decimals_with_comma_separator') return p[0];
      return whole + '.' + p[1];
    });
  }
  function norm(s) { return (s || '').toLowerCase(); }
  function compact(s) { return norm(s).replace(/[\s\-–—.,()\/_]+/g, ''); }
  function toast(msg, err, link, ms) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    if (link) {
      // product pages have no basket bar, so the message carries the way to the basket
      var a = document.createElement('a');
      a.href = '/cart'; a.textContent = 'View basket →'; a.style.marginLeft = '8px'; a.style.fontWeight = '800';
      toastEl.appendChild(a);
    }
    toastEl.className = 'mpl-toast' + (err ? ' is-err' : '');
    toastEl.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { toastEl.hidden = true; }, ms || (err ? 4200 : (link ? 4500 : 1800)));
  }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- short part names (same rules as the trade price list) ---------- */
  var MODEL_WORDS = ['PCX\\s*150', 'ADV\\s*150', 'ADV\\s*350', 'ADV', 'N-?MAX\\s*125', 'NMAX', 'N\\s?Max', 'GPD\\s?125', 'PCX\\s*125', 'PCX',
    'Vision\\s*110', 'SH\\s?125i', 'SH125', 'SH\\s*Mode\\s*125', 'SH\\s*Mode', 'SH350i', 'Forza\\s*/\\s*NSS', 'Forza\\s*(?:125|300|350)?', 'NSS',
    'X-?MAX\\s*(?:125|300)?', 'Address\\s*110', 'Aerox\\s*155', 'NVX', 'Liberty\\s*125', 'RayZR\\s*125', 'CB125F', 'Vario\\s*125'];
  var MW = MODEL_WORDS.map(function (w) { return new RegExp('\\b' + w + '\\b', 'gi'); });
  var MAKERS = ['Honda', 'Yamaha', 'Suzuki', 'Piaggio'].map(function (w) { return new RegExp('\\b' + w + '\\b', 'g'); });
  function titleCase(s) { return s.toLowerCase().replace(/(^|[^A-Za-z'])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function shortName(title, oes, sku) {
    var s = title || '';
    s = s.replace(/^Fits\s+/, '').replace(/Samll/g, 'Small');
    s = s.replace(/\((Import Model)\)/gi, '');
    s = s.replace(/^Fits\s+(Scooter|Honda|Yamaha)\s+/, '');
    s = s.replace(/\bGenuine\b/g, '');
    MAKERS.forEach(function (re) { s = s.replace(re, ''); });
    MW.forEach(function (re) { s = s.replace(re, ''); });
    s = s.replace(/\bV[1-6]\b/g, '').replace(/\beSP\b/g, '');
    s = s.replace(/\b(19|20)\d{2}\s*[-–]\s*(19|20)?\d{2,4}\b/g, '');
    s = s.replace(/\b(19|20)\d{2}\s*\+/g, '');
    s = s.replace(/\b(19|20)\d{2}\b/g, '');
    (oes || []).concat(sku ? [sku] : []).forEach(function (o) { if (o) s = s.split(o).join(''); });
    s = s.replace(/\b[0-9A-Z]{3,5}-[0-9A-Z]{3,5}-[0-9A-Z]{2,6}(-[0-9A-Z]{2,4})?\b/g, '');
    s = s.replace(/\((K[0-9A-Z]{2}|KVY|KVB|K12|KWN|B6H|2DP|BLS|K1B|K0B|K2A|K0R|K77)\)/g, '');
    s = s.replace(/\(\s*\)/g, '');
    s = s.replace(/ ,/g, ',').replace(/\( /g, '(').replace(/ \)/g, ')');
    s = s.replace(/\s*\/\s*(?=\s)/g, ' ');
    s = s.replace(/^[\s\-–—\/,:]+|[\s\-–—\/,:]+$/g, '');
    s = s.replace(/\s{2,}/g, ' ').trim();
    s = s.replace(/^(\/|&)\s*/, '').replace(/^Fits\s+/, '');
    s = s.replace(/\s*[–—-]\s*[+,\/\s]*$/, '');
    s = s.replace(/(^|[^-\w])(K97|K1Z|K1Y|K35|KWN|K0R|K2C|K44|KZL|K77|K01|K1N|K1W|K40|K0B|K1B|K2A|B6H|2DP|BLS|B74|BKA|BEJ)(?![-\w])/g, '$1');
    s = s.split(' for (').join(' (');
    s = s.replace(/\s+(\d{4,5}[A-Z]?(--\d{3}|-[A-Z0-9][A-Za-z0-9]*|-n max\d+)?)$/, '');
    s = s.replace(/^(Left|Right)\.\s/, '$1 ');
    s = s.replace('Front,Left', 'Front Left').replace('Blue Blue', 'Blue');
    s = s.replace(/^(\d+)\s(\d)X(\d+)X(\d+)\s+(.+)$/, function (m, a, b, c, d, e) { return e + ' ' + a + '.' + b + 'x' + c + 'x' + d; });
    s = s.replace(/^([\d.]+[Xx*][\d.]+[Xx*][\d.]+)\s+(.+)$/, function (m, a, b) { return b + ' ' + a.toLowerCase(); });
    s = s.replace(/\s{2,}/g, ' ').trim();
    s = s.replace(/\s*[—–-]\s*Pair \(Left \+ Right\)/, ', pair (L+R)');
    s = s.replace(/\s*Pair \(Left \+ Right\)/, ', pair (L+R)');
    s = s.replace(/\s*\(Left \+ Righ\b.*$/, ', pair (L+R)');
    s = s.replace(/^[\s,.\-]+/, '').trim();
    if (s && s === s.toUpperCase() && /[A-Z]/.test(s)) s = titleCase(s);
    if (s.length < 3) return title;
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* ---------- bike generation labels ---------- */
  function fitLabel(f) { return (f || '').replace(/^(Honda|Yamaha|Suzuki|Piaggio|Vespa)\s+/, '').replace(/\s+/g, ' ').trim(); }
  function yearsOf(label) {
    var m = /((?:19|20)\d{2})\s*(?:[–-]\s*((?:19|20)?\d{2,4})|(\+))?\s*$/.exec(label || '');
    if (!m) return null;
    var a = +m[1], b = a;
    if (m[3]) b = 2099;
    else if (m[2]) { b = m[2].length === 2 ? +(String(a).slice(0, 2) + m[2]) : +m[2]; }
    return [a, b];
  }
  function commonPrefix(labels) {
    if (labels.length < 2) return '';
    var w = labels.map(function (l) { return l.split(' '); });
    var out = [];
    for (var i = 0; i < w[0].length - 1; i++) {
      var tok = w[0][i];
      if (w.every(function (x) { return x.length > i + 1 && x[i] === tok; })) out.push(tok); else break;
    }
    return out.join(' ');
  }
  function stripPrefix(l) { return chipPrefix && l.indexOf(chipPrefix + ' ') === 0 ? l.slice(chipPrefix.length + 1) : l; }

  /* ---------- rows ---------- */
  var rows = [];
  function prep(li) {
    if (li._mpl) return li._mpl;
    var d = li.dataset;
    var oes = d.o ? d.o.split('|') : [];
    var fits = d.f ? d.f.split('|').map(fitLabel) : [];
    var nameEl = li.querySelector('.mpl-nm');
    var title = d.t || (nameEl ? nameEl.textContent : '');
    var nm = shortName(title, oes, d.s);
    if (nameEl) { nameEl.textContent = nm; nameEl.title = title; }
    var r = {
      el: li, g: +d.g, sub: d.sub || '', name: nm, title: title, fits: fits, years: d.y ? yearsOf(d.y.replace('-', '–')) : null,
      avail: d.a === '1',
      hay: norm(nm + ' ' + title + ' ' + oes.join(' ') + ' ' + (d.s || '') + ' ' + (d.vt || '')),
      hayc: compact(oes.join(' ') + ' ' + (d.s || '') + ' ' + title),
      step: li.querySelector('.mpl-step'), sel: li.querySelector('.mpl-var'), price: li.querySelector('[data-mpl-price]')
    };
    li._mpl = r;
    rows.push(r);
    paintRow(r);
    return r;
  }
  function paintFits() {
    rows.forEach(function (r) {
      var f = r.el.querySelector('.mpl-fit');
      if (!f) return;
      var labels = r.fits.map(stripPrefix);
      if (!labels.length && r.el.dataset.y) labels = [r.el.dataset.y.replace('-', '–')];
      f.textContent = labels.length > 2 ? labels.slice(0, 2).join(' · ') + ' +' + (labels.length - 2) + ' more' : labels.join(' · ');
    });
  }
  function curVariant(r) { return r.step ? r.step.getAttribute('data-v') : null; }
  function stepInfo(r) {
    var min = 1, inc = 1;
    var so = r.sel ? r.sel.options[r.sel.selectedIndex] : null;
    if (so) {
      min = +so.getAttribute('data-min') || 1; inc = +so.getAttribute('data-inc') || 1;
    } else if (r.step) {
      min = +r.step.getAttribute('data-min') || 1; inc = +r.step.getAttribute('data-inc') || 1;
    }
    return { min: min, inc: inc };
  }
  function qtyOf(v) { return v in want ? want[v] : (cartQty[v] || 0); }
  function paintRow(r) {
    if (!r.step) return;
    var v = curVariant(r), n = qtyOf(v);
    r.step.classList.toggle('has', n > 0);
    r.step.classList.toggle('busy', !!inflight[v]);
    var nEl = r.step.querySelector('.mpl-n');
    if (nEl) {
      // the typed quantity box: never overwrite what the customer is typing
      if (nEl.tagName === 'INPUT') { if (document.activeElement !== nEl) nEl.value = n; }
      else nEl.textContent = n;
    }
    r.el.classList.toggle('is-in', n > 0);
  }
  function paintVariant(v) { rows.forEach(function (r) { if (curVariant(r) === String(v)) paintRow(r); }); }
  function paintAll() { rows.forEach(paintRow); }

  /* ---------- cart ---------- */
  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var s = doc.querySelector('.shopify-section');
    b.innerHTML = s ? s.innerHTML : doc.body.innerHTML;
  }
  function liftChat() {
    var c = document.querySelector('shopify-chat');
    if (!c || !c.shadowRoot || !dock) return;
    var st = c.shadowRoot.getElementById('mpl-lift');
    if (!st) { st = document.createElement('style'); st.id = 'mpl-lift'; c.shadowRoot.appendChild(st); }
    st.textContent = dock.hidden ? '' : '.activator-nudge{transform:translateY(-' + (dock.offsetHeight + 6) + 'px)}';
  }
  var FREE = +cfg.free || 0;
  function shipMsg(cart) {
    // free UK delivery progress; panel kits / oversized items ship on their own rate, so say nothing for those baskets
    if (!FREE || !cart.item_count) return '';
    var left = FREE - (cart.total_price || 0);
    return left > 0 ? money(left) + ' to the £300 minimum' : '✓ Free <span class="mpl-uk">UK </span>delivery';
  }
  function paintDock(cart) {
    if (!dock) return;
    var n = cart.item_count || 0;
    dock.hidden = n === 0;
    document.body.classList.toggle('mpl-has-dock', n > 0);
    liftChat();
    var i = dock.querySelector('[data-mpl-items]'), t = dock.querySelector('[data-mpl-total]'), sh = dock.querySelector('[data-mpl-ship]');
    if (i) i.textContent = n;
    if (t) t.textContent = money(cart.total_price || 0);
    if (sh) { var m = shipMsg(cart); sh.innerHTML = m; sh.classList.toggle('is-ok', m.charAt(0) === '✓'); }
  }
  function readCart(cart) {
    cartQty = {};
    (cart.items || []).forEach(function (it) { cartQty[it.variant_id] = (cartQty[it.variant_id] || 0) + it.quantity; });
    Object.keys(want).forEach(function (v) { if (!timers[v] && !inflight[v] && !(v in pending)) delete want[v]; });
    paintAll();
    paintDock(cart);
  }
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(readCart).catch(function () {});
  }
  function post(url, data) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status === 422 || j.status === 'bad_request') {
          var e = new Error(j.description || j.message || 'Could not update your basket'); throw e;
        }
        return j;
      });
    });
  }
  function minOf(v) {
    for (var i = 0; i < rows.length; i++) if (curVariant(rows[i]) === String(v)) return stepInfo(rows[i]).min;
    return 1;
  }
  function sync(v, nameForToast) {
    clearTimeout(timers[v]); delete timers[v];
    // one request per part at a time; a change made meanwhile is sent when the running one finishes
    if (inflight[v]) { pending[v] = nameForToast || pending[v] || ''; return; }
    var target = want[v];
    if (target === undefined) return;
    var had = cartQty[v] || 0;
    if (target === had) { delete want[v]; paintVariant(v); return; }
    inflight[v] = true; paintVariant(v);
    var req, failed = false;
    if (had === 0) {
      req = post('/cart/add.js', { items: [{ id: +v, quantity: target }], sections: 'cart-icon-bubble' }).catch(function (err) {
        // not enough stock for the whole amount: add the minimum, then ask for the full amount (Shopify caps it at what is in stock)
        var m = minOf(v);
        if (target <= m) throw err;
        return post('/cart/add.js', { items: [{ id: +v, quantity: m }] }).then(function () {
          var u = {}; u[v] = target;
          return post('/cart/update.js', { updates: u, sections: 'cart-icon-bubble' });
        });
      });
    } else { var u = {}; u[v] = target; req = post('/cart/update.js', { updates: u, sections: 'cart-icon-bubble' }); }
    req.then(function (res) {
      updateBubble(res.sections);
      if (target > had && nameForToast) {
        // first add on this device: say once that the number can be typed (for trade orders of 20, 50, 100...)
        var tip = '';
        if (had === 0 && target === minOf(v) && !lsGet('mpl_qtip')) { tip = ' — tap the number to type any quantity.'; lsSet('mpl_qtip', '1'); }
        toast('Added: ' + nameForToast + tip, false, !dock, tip ? 4000 : 0);
      }
    }).catch(function (err) {
      failed = true;
      delete want[v];
      toast(err.message, true);
    }).then(function () {
      delete inflight[v];
      if (want[v] === target) delete want[v];
      return refreshCart();
    }).then(function () {
      var got = cartQty[v] || 0;
      if (!failed && !(v in pending) && want[v] === undefined && got > 0 && got < target && target > had) {
        toast('Only ' + got + ' in stock right now, so your basket has ' + got + '.', true);
      }
      if (v in pending) {
        var nm = pending[v]; delete pending[v];
        if (want[v] !== undefined) { sync(v, nm || nameForToast); return; }
      }
      if (want[v] !== undefined && !timers[v]) sync(v, nameForToast);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  }
  function labelOf(r) {
    var so = r.sel ? r.sel.options[r.sel.selectedIndex] : null;
    return r.name + (so ? ' (' + so.textContent.trim() + ')' : '');
  }
  function change(r, dir) {
    var v = curVariant(r);
    if (!v) return;
    var si = stepInfo(r);
    var n = qtyOf(v);
    var next;
    if (dir > 0) next = n === 0 ? Math.max(si.min, si.inc) : n + si.inc;
    else next = n - si.inc < si.min ? 0 : n - si.inc;
    want[v] = Math.max(0, next);
    paintVariant(v);
    clearTimeout(timers[v]);
    var label = labelOf(r);
    timers[v] = setTimeout(function () { sync(v, label); }, 380);
  }
  function commitQty(r, el) {
    // the customer typed a quantity (e.g. 100): round to the part's minimum / pack size, 0 removes it
    var v = curVariant(r);
    if (!v) return;
    var raw = String(el.value || '').replace(/[^0-9]/g, '');
    if (raw === '') { paintRow(r); return; }
    var si = stepInfo(r), n = Math.min(parseInt(raw, 10), 999);
    if (n > 0 && n < si.min) n = si.min;
    if (n > 0 && si.inc > 1 && n % si.inc) n = Math.ceil(n / si.inc) * si.inc;
    clearTimeout(timers[v]); delete timers[v];
    if (n === qtyOf(v)) { el.value = n; paintRow(r); return; }
    want[v] = n;
    el.value = n;
    paintVariant(v);
    sync(v, labelOf(r));
  }

  /* ---------- groups, chips, filters ---------- */
  function groupEl(g) { return body.querySelector('.mpl-grp[data-grp="' + g + '"]'); }
  function ensureGroup(g) {
    var el = groupEl(g);
    if (el) return el;
    el = document.createElement('section');
    el.className = 'mpl-grp'; el.setAttribute('data-grp', g); el.id = 'mpl-g' + g;
    el.innerHTML = '<h2 class="mpl-gh"><span></span><small data-mpl-gn></small></h2><ul class="mpl-list" data-list="' + g + '"></ul>';
    el.querySelector('.mpl-gh span').textContent = GN[g] || 'Other parts';
    var after = null;
    Array.prototype.forEach.call(body.querySelectorAll('.mpl-grp'), function (x) { if (+x.getAttribute('data-grp') < g) after = x; });
    if (after) after.parentNode.insertBefore(el, after.nextSibling);
    else { var first = body.querySelector('.mpl-grp'); body.insertBefore(el, first || moreEl || noneEl); }
    return el;
  }
  function sortGroups() {
    Array.prototype.forEach.call(body.querySelectorAll('.mpl-list'), function (ul) {
      Array.prototype.forEach.call(ul.querySelectorAll('.mpl-subh'), function (h) { h.remove(); });
      var items = Array.prototype.slice.call(ul.children).map(function (li) { return li._mpl || prep(li); });
      var subs = {};
      items.forEach(function (r) { subs[r.sub] = 1; });
      var useSubs = items.length >= 16 && Object.keys(subs).filter(Boolean).length >= 2;
      items.sort(function (a, b) {
        if (useSubs && a.sub !== b.sub) {
          if (!a.sub) return 1;
          if (!b.sub) return -1;
          return subLabel(a.sub).localeCompare(subLabel(b.sub));
        }
        if (a.avail !== b.avail) return a.avail ? -1 : 1;
        var c = a.name.localeCompare(b.name, 'en', { sensitivity: 'base', numeric: true });
        if (c) return c;
        return (a.fits[0] || '').localeCompare(b.fits[0] || '');
      });
      var frag = document.createDocumentFragment(), last = null;
      items.forEach(function (r) {
        if (useSubs && r.sub !== last) {
          var h = document.createElement('li'); h.className = 'mpl-subh'; h.setAttribute('aria-hidden', 'true');
          h.textContent = r.sub ? subLabel(r.sub) : 'Other';
          frag.appendChild(h); last = r.sub;
        }
        frag.appendChild(r.el);
      });
      ul.appendChild(frag);
    });
  }
  function famOf(l) {
    return l.replace(/\s*\([^)]*\)/g, '').replace(/\s+V\d\b/g, '').replace(/\s+eSP\b/g, '')
      .replace(/\s*(?:19|20)\d{2}\s*(?:[–-]\s*(?:19|20)?\d{2,4}|\+)?\s*$/, '').replace(/\s+/g, ' ').trim();
  }
  function chip(label, value, pressed) {
    var b = document.createElement('button'); b.type = 'button'; b.textContent = label;
    b.setAttribute('data-gen', value); b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    return b;
  }
  function buildGens() {
    if (!gensBox) return;
    var count = {}, famRows = {}, withFits = 0;
    rows.forEach(function (r) {
      if (r.fits.length) withFits++;
      var seen = {};
      r.fits.forEach(function (f) { count[f] = (count[f] || 0) + 1; var fm = famOf(f); if (!seen[fm]) { seen[fm] = 1; famRows[fm] = (famRows[fm] || 0) + 1; } });
    });
    var fams = Object.keys(famRows).sort(function (a, b) { return famRows[b] - famRows[a]; });
    var wordRows = {};
    rows.forEach(function (r) { var seen = {}; r.fits.forEach(function (f) { var w = famOf(f).split(' ')[0]; if (!seen[w]) { seen[w] = 1; wordRows[w] = (wordRows[w] || 0) + 1; } }); });
    var topWord = Object.keys(wordRows).sort(function (a, b) { return wordRows[b] - wordRows[a]; })[0] || '';
    var byBike = !!cfg.search || (withFits > 0 && (wordRows[topWord] || 0) / withFits < 0.7);
    // under the classic collection banner the bike is already chosen (and the fitment hint links the other generations)
    if (cfg.classic && !byBike) { gensBox.hidden = true; state.gen = ''; return; }
    var labels, values, title;
    if (byBike) {
      values = fams.filter(function (f) { return famRows[f] >= 2; }).map(function (f) { return 'fam:' + f; });
      labels = values.map(function (v) { return v.slice(4); });
      chipPrefix = '';
      title = 'Bike:';
    } else {
      var minN = Math.max(2, Math.ceil(rows.length * 0.04));
      values = Object.keys(count).filter(function (l) { return count[l] >= minN && l.split(' ')[0] === topWord; });
      values.sort(function (a, b) { var ya = yearsOf(a) || [0], yb = yearsOf(b) || [0]; return (ya[0] - yb[0]) || a.localeCompare(b); });
      var pre = commonPrefix(values.length > 1 ? values : Object.keys(count).filter(function (l) { return l.split(' ')[0] === topWord; }));
      chipPrefix = pre.split(' ').length >= 2 ? pre : '';
      labels = values.map(stripPrefix);
      title = 'Years:';
    }
    if (values.length < 2 || values.length > 16) { gensBox.hidden = true; state.gen = ''; return; }
    if (state.gen && values.indexOf(state.gen) < 0) state.gen = '';
    gensBox.innerHTML = '';
    var lab = document.createElement('span'); lab.className = 'mpl-gl'; lab.textContent = title; gensBox.appendChild(lab);
    gensBox.appendChild(chip('All', '', !state.gen));
    values.forEach(function (v, i) { var b = chip(labels[i], v, v === state.gen); b.title = v.indexOf('fam:') === 0 ? v.slice(4) : v; gensBox.appendChild(b); });
    gensBox.hidden = false;
  }
  function fitsGen(r, gen) {
    if (!gen) return true;
    if (gen.indexOf('fam:') === 0) {
      if (!r.fits.length) return true;
      var fm = gen.slice(4);
      return r.fits.some(function (f) { return famOf(f) === fm; });
    }
    if (r.fits.length) return r.fits.indexOf(gen) > -1;
    var gy = yearsOf(gen);
    if (r.years && gy) return r.years[0] <= gy[1] && r.years[1] >= gy[0];
    return true;
  }
  function matches(r) {
    if (!fitsGen(r, state.gen)) return false;
    if (!state.term) return true;
    var toks = norm(state.term).split(/\s+/).filter(Boolean);
    return toks.every(function (t) { return r.hay.indexOf(t) > -1 || (compact(t).length > 2 && r.hayc.indexOf(compact(t)) > -1); });
  }
  function applyFilter() {
    var shown = 0, per = {};
    rows.forEach(function (r) {
      var ok = matches(r);
      r.el.hidden = !ok;
      if (ok) { shown++; per[r.g] = (per[r.g] || 0) + 1; }
    });
    Array.prototype.forEach.call(body.querySelectorAll('.mpl-subh'), function (h) {
      var n = h.nextElementSibling, any = false;
      while (n && !n.classList.contains('mpl-subh')) { if (!n.hidden) { any = true; break; } n = n.nextElementSibling; }
      h.hidden = !any;
    });
    Array.prototype.forEach.call(body.querySelectorAll('.mpl-grp'), function (sec) {
      var g = +sec.getAttribute('data-grp'), n = per[g] || 0;
      sec.hidden = n === 0;
      var s = sec.querySelector('[data-mpl-gn]'); if (s) s.textContent = n + (n === 1 ? ' part' : ' parts');
    });
    if (countEl) countEl.textContent = shown;
    if (noneEl) noneEl.hidden = shown > 0 || rows.length === 0;
    buildCats(per);
  }
  function buildCats(per) {
    if (!catsNav) return;
    var keys = Object.keys(per).map(Number).sort(function (a, b) { return a - b; });
    if (keys.length < 2) { catsNav.hidden = true; catsNav.innerHTML = ''; return; }
    catsNav.hidden = false;
    catsNav.innerHTML = '';
    keys.forEach(function (g) {
      var a = document.createElement('a');
      a.href = '#mpl-g' + g; a.setAttribute('data-g', g);
      a.appendChild(document.createTextNode(GS[g] || GN[g] || 'Other'));
      var sm = document.createElement('small'); sm.textContent = per[g]; a.appendChild(sm);
      catsNav.appendChild(a);
    });
    spy();
  }
  function stickyTop() {
    var h = document.querySelector('.section-header'), t = 0;
    if (h) {
      var cs = getComputedStyle(h);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && !h.classList.contains('shopify-section-header-hidden')) t = Math.round(h.getBoundingClientRect().height);
    }
    root.style.setProperty('--mpl-top', t + 'px');
    return t;
  }
  function smoothTo(el, opts) { try { el.scrollTo(opts); } catch (e) { if (opts.top !== undefined) window.scrollTo(0, opts.top); else el.scrollLeft = opts.left; } }
  function jumpTo(g) {
    var sec = groupEl(g);
    if (!sec) return;
    var off = stickyTop() + (tools ? tools.offsetHeight : 0) + 6;
    var y = sec.getBoundingClientRect().top + window.pageYOffset - off;
    smoothTo(window, { top: Math.max(0, y), behavior: 'smooth' });
  }
  var spyRaf = 0;
  function spy() {
    if (spyRaf || !catsNav || catsNav.hidden) return;
    spyRaf = requestAnimationFrame(function () {
      spyRaf = 0;
      var off = (parseInt(getComputedStyle(root).getPropertyValue('--mpl-top'), 10) || 0) + (tools ? tools.offsetHeight : 0) + 20;
      var cur = null;
      Array.prototype.forEach.call(body.querySelectorAll('.mpl-grp:not([hidden])'), function (sec) { if (sec.getBoundingClientRect().top <= off) cur = sec.getAttribute('data-grp'); });
      Array.prototype.forEach.call(catsNav.querySelectorAll('a'), function (a) {
        var on = a.getAttribute('data-g') === cur;
        if (on && !a.classList.contains('is-on')) {
          var l = a.offsetLeft - 12;
          if (l < catsNav.scrollLeft || l + a.offsetWidth > catsNav.scrollLeft + catsNav.clientWidth) smoothTo(catsNav, { left: Math.max(0, l), behavior: 'smooth' });
        }
        a.classList.toggle('is-on', on);
      });
    });
  }

  /* ---------- extra pages ---------- */
  function loadPages() {
    if (!moreEl) return Promise.resolve();
    var pages = +moreEl.getAttribute('data-mpl-pages') || 1, cur = +moreEl.getAttribute('data-mpl-page') || 1;
    if (pages <= 1) return Promise.resolve();
    moreEl.hidden = false;
    var list = [];
    for (var p = 1; p <= pages; p++) if (p !== cur) list.push(p);
    var chain = Promise.resolve();
    list.forEach(function (p) {
      chain = chain.then(function () {
        var u = new URL(window.location.href);
        u.searchParams.set('page', p);
        u.searchParams.set('section_id', cfg.section);
        return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          Array.prototype.forEach.call(doc.querySelectorAll('.mpl-row'), function (li) {
            var node = document.importNode(li, true);
            var g = +node.getAttribute('data-g');
            ensureGroup(g).querySelector('.mpl-list').appendChild(node);
            prep(node);
          });
        }).catch(function () {});
      });
    });
    return chain.then(function () { moreEl.hidden = true; });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest ? t.closest('.mpl-plus, .mpl-minus') : null;
    if (btn) {
      var li = btn.closest('.mpl-row');
      if (li) { change(li._mpl || prep(li), btn.classList.contains('mpl-plus') ? 1 : -1); }
      return;
    }
    var vb = t.closest ? t.closest('[data-mpl-view]') : null;
    if (vb) { setView(vb.getAttribute('data-mpl-view')); return; }
    var gb = t.closest ? t.closest('[data-gen]') : null;
    if (gb) {
      state.gen = gb.getAttribute('data-gen');
      Array.prototype.forEach.call(gensBox.querySelectorAll('[data-gen]'), function (b) { b.setAttribute('aria-pressed', b === gb ? 'true' : 'false'); });
      applyFilter();
      return;
    }
    var ca = t.closest ? t.closest('[data-mpl-cats] a') : null;
    if (ca) { e.preventDefault(); jumpTo(ca.getAttribute('data-g')); }
  });
  function qtyBox(t) { return t && t.classList && t.classList.contains('mpl-n') && t.tagName === 'INPUT' ? t : null; }
  root.addEventListener('focusin', function (e) {
    var q = qtyBox(e.target);
    if (!q) return;
    q._fresh = true;
    setTimeout(function () { if (q._fresh && document.activeElement === q) { try { q.setSelectionRange(0, q.value.length); } catch (x) {} } }, 0);
  });
  root.addEventListener('beforeinput', function (e) {
    // the first key after tapping the box starts a new number (so "1" then typing 100 gives 100, not 110),
    // even on phones that do not select the old number
    var q = qtyBox(e.target);
    if (!q || !q._fresh) return;
    q._fresh = false;
    var t = e.inputType || '';
    if (t === 'insertText' && e.data != null) {
      e.preventDefault();
      q.value = String(e.data).replace(/[^0-9]/g, '').slice(0, 3);
    } else if (t.indexOf('delete') === 0) {
      e.preventDefault();
      q.value = '';
    } else if (t.indexOf('insert') === 0) {
      q.value = '';
    }
    try { q.setSelectionRange(q.value.length, q.value.length); } catch (x) {}
  });
  root.addEventListener('focusout', function (e) {
    var q = qtyBox(e.target);
    if (!q) return;
    q._fresh = false;
    var li = q.closest('.mpl-row');
    if (li) commitQty(li._mpl || prep(li), q);
  });
  root.addEventListener('input', function (e) {
    var q = qtyBox(e.target);
    if (!q) return;
    var c = q.value.replace(/[^0-9]/g, '').slice(0, 3);
    if (c !== q.value) q.value = c;
  });
  root.addEventListener('keydown', function (e) {
    var q = qtyBox(e.target);
    if (!q) return;
    if (e.key === 'Enter') { e.preventDefault(); q.blur(); }
    else if (e.key === 'Escape') { var li = q.closest('.mpl-row'), r = li && (li._mpl || prep(li)); q.value = r ? qtyOf(curVariant(r)) : q.defaultValue; q.blur(); }
  });
  root.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('mpl-var')) return;
    var sel = e.target, li = sel.closest('.mpl-row'), r = li._mpl || prep(li);
    var o = sel.options[sel.selectedIndex];
    if (r.step) { r.step.setAttribute('data-v', sel.value); r.step.setAttribute('data-min', o.getAttribute('data-min') || 1); r.step.setAttribute('data-inc', o.getAttribute('data-inc') || 1); }
    if (r.price) r.price.textContent = money(+o.getAttribute('data-p') || 0);
    var s = li.querySelector('.mpl-pr s'), c = +o.getAttribute('data-c') || 0, p = +o.getAttribute('data-p') || 0;
    if (s) { if (c > p) { s.textContent = money(c); s.hidden = false; } else s.hidden = true; }
    paintRow(r);
  });
  // going to the basket or checkout while a change is still being saved (e.g. typed 100, then tapped Checkout straight away):
  // send the change first, then go, so the basket is never one step behind
  function busy() { return Object.keys(inflight).length + Object.keys(timers).length + Object.keys(pending).length > 0; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var h = a.getAttribute('href') || '';
    if (!/^\/(cart|checkout)(\/|\?|$)/.test(h) && h.indexOf('/checkouts/') < 0) return;
    var q = document.activeElement;
    if (qtyBox(q)) q.blur();
    if (!busy()) return;
    e.preventDefault();
    Object.keys(timers).forEach(function (v) { sync(v, ''); });
    var tries = 0;
    (function go() { if (!busy() || ++tries > 60) { window.location.href = a.href; return; } setTimeout(go, 100); })();
  }, true);
  var ft = 0;
  if (findInput) findInput.addEventListener('input', function () {
    clearTimeout(ft);
    ft = setTimeout(function () { state.term = findInput.value.trim(); applyFilter(); }, 90);
  });
  function setView(v) {
    var photos = v === 'photos';
    root.classList.toggle('is-photos', photos);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mpl-view]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mpl-view') === v ? 'true' : 'false'); });
    lsSet('mpl_view', photos ? 'photos' : 'list');
  }
  window.addEventListener('scroll', spy, { passive: true });
  window.addEventListener('resize', function () { stickyTop(); spy(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshCart(); });

  /* ---------- start ---------- */
  if (lsGet('mpl_view') === 'photos') setView('photos');
  stickyTop();
  Array.prototype.forEach.call(body.querySelectorAll('.mpl-row'), prep);
  buildGens(); paintFits(); sortGroups(); applyFilter();
  refreshCart();
  setTimeout(liftChat, 2500); window.addEventListener('load', function () { setTimeout(liftChat, 1500); });
  loadPages().then(function () {
    buildGens(); paintFits(); sortGroups(); applyFilter(); paintAll();
  });
})();
